/**
 * Radius of the earth in kilometers
 */
export const EARTHS_RADIUS = 6371;
